import React from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import Fab from '@material-ui/core/Fab'
import { withStyles } from '@material-ui/core/styles'
import DoneIcon from '@material-ui/icons/Done'
import styles from './styles'
import { saveButtonDisabledSelector } from 'selectors'
import { addOrUpdateTask, receiveTask } from 'actions/tasks'
import { withRouter } from 'react-router-dom'
import { last } from 'lodash'

export default withRouter(
  connect(
    state => ({
      disabled: saveButtonDisabledSelector(state),
      value: state.tasks.addOrEdit.fields.selectedActionPrediction.value,
      emailCardSelected: last(state.email.cardSelected),
      taskID: state.tasks.addOrEdit.taskID,
    }),
    dispatch => bindActionCreators({ addOrUpdateTask, receiveTask }, dispatch)
  )(
    withStyles(styles)(
      ({
        classes,
        disabled,
        addOrUpdateTask,
        history,
        taskID,
        value,
        emailCardSelected,
        receiveTask,
        modal,
      }) => (
        <Fab
          onClick={() => {
            if (taskID === 'new') {
              addOrUpdateTask().then(({ payload }) => {
                if (payload) {
                  history.replace(`/tasks/${payload.id}`)
                }
              })
            } else {
              addOrUpdateTask().then(({ payload }) => {
                if (payload) {
                  receiveTask(payload)
                }
              })
            }
          }}
          style={modal ? { position: 'absolute', bottom: 5, right: 10 } : {
            bottom:
              value === 'email' && emailCardSelected === 'blank'
                ? '79px'
                : '23px',
          }}
          // disabled={disabled}
          className={classes.floatingActionButton}
          color="secondary"
        >
          <DoneIcon />
        </Fab>
      )
    )
  )
)

